import { combineReducers } from "redux";
import { authenticationSlice } from "@/Slices/authenticationSlice";
import { bookShipmentSlice } from "@/Slices/bookShipmentSlice";
import { lineItemsNmfcDescriptionCacheSlice } from "@/Slices/nmfcDescriptionCacheSlice";
import { couponSlice } from "@/Slices/couponSlice";
import { reactionsSlice } from "@/Shared/Reactions/useReaction";

/**
 * The app's slice map, in its own file so a story can stand up an isolated
 * store from the real shape (see Shared/Storybook/StoryStoreProvider) rather
 * than hand-picking slices — a partial store breaks as soon as the component
 * under test reads a slice nobody thought to include.
 */
export const rootReducer = combineReducers({
  authentication: authenticationSlice.reducer,
  reactions: reactionsSlice.reducer,
  bookShipment: bookShipmentSlice.reducer,
  nmfcDesciptionCache: lineItemsNmfcDescriptionCacheSlice.reducer,
  coupon: couponSlice.reducer,
});
